import React from "react";
import moment from "moment";
import { Link, Redirect } from "react-router-dom";
import { getData } from "../services/index";
import {
  message,
  Collapse,
  Radio,
  Checkbox,
  label,
  Input,
  Popover,
  Button,
  Tooltip,
  TimePicker,
  Select,
  DatePicker,
  Upload,
  Modal,
} from "antd";
import {
  LineOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
} from "@ant-design/icons";
const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
const buttonWidth = 70;
function callback(key) {
  console.log(key);
}
function onChange(time, timeString) {
  console.log(time, timeString);
}
function disabledDate(current) {
  // Can not select days before today and today
  return current && current > moment().endOf("day");
}
function onChangechecked(checkedValues) {
  console.log("checked = ", checkedValues);
}
const dateFormat = "YYYY-MM-DD";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
function yearDiff(dt1, dt2) {
  var diffYear = (dt2.getTime() - dt1.getTime()) / 1000;
  diffYear /= 60 * 60 * 24;
  return Math.abs(Math.round(diffYear / 365.25));
}
class Index extends React.Component {
  static contextTypes = {
    router: () => null,
  };
  constructor(props) {
    super(props);
    this.state = {
      city_list: [],
      state_list: [],
      loading: false,
      user_id: "",
      name: "",
      assign_label: "",
      primary_mobile: "",
      old_primary_mobile: "",
      secondary_mobile: "",
      email: "",
      old_email: "",
      locality: "",
      city: "",
      relation: "",
      child_name: "",
      gender: "",
      birthday: "",
      age: "",
      program_intrested: "",
      notes: "",
      date_of_enquiry: "",
      follow_up_date: "",
      how_know: "",
      currentDate: "",
      academic_year: "",
      is_important: 0,
      school_list: [],
      academic_year_: [],
      manage_class: [],
      place_search: [],
      search_latitude: "",
      search_longitude: "",
      search_addr: "",
      tag_name: [],
    };
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.onChangebirthday = this.onChangebirthday.bind(this);
    this.onChangejoin = this.onChangejoin.bind(this);
    this.change_blood_group = this.change_blood_group.bind(this);
    this.change_label = this.change_label.bind(this);
    this.change_gender = this.change_gender.bind(this);
    this.change_relation = this.change_relation.bind(this);
    this.change_program = this.change_program.bind(this);
    this.change_how_know = this.change_how_know.bind(this);
    this.change_year = this.change_year.bind(this);
    this.onChangeenquiry = this.onChangeenquiry.bind(this);
    this.onChangefollow = this.onChangefollow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.goBack = this.goBack.bind(this);
    this.change_state = this.change_state.bind(this);
    this.change_city = this.change_city.bind(this);
    this.handlenext = this.handlenext.bind(this);
  }
  componentWillMount() {
    document.querySelector(".loader-wrapper").style = "display: none";
    setTimeout(() => {
      document.querySelector(".loader-wrapper").style = "display: none";
    }, 500);
    if (!localStorage.getItem("schoolData")) {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      if (params.mtoken != null) {
        let auth_token = params.mtoken;
        var app = { token: auth_token };
        getData("kidzonia_parents/check_school_token", app).then((result) => {
          let responseJson = result;
          if (responseJson) {
            if (result["status"] == 200) {
              localStorage.setItem("schoolData", JSON.stringify(responseJson));
              this.setState({
                user_id: result["data"][0]["user_id"],
                id: this.props.match.params.id,
                school_id: result["data"][0]["school_id"],
              });
              this.checkData();
            } else {
              localStorage.setItem("schoolData", "");
              localStorage.clear();
              window.location.href = "/app_404?mtoken=" + auth_token;
            }
          }
        });
      } else {
        localStorage.setItem("schoolData", "");
        localStorage.clear();
        window.location.href = "/login";
      }
    } else {
      var storedArray = JSON.parse(localStorage.getItem("schoolData"));
      this.setState({
        user_id: storedArray["data"][0]["user_id"],
        id: this.props.match.params.id,
        school_id: storedArray["data"][0]["school_id"],
      });
      this.checkData();
    }
    var date = new Date();
    var currentDate =
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    this.setState({ currentDate: currentDate });
  }
  checkData() {
    if (localStorage.getItem("schoolData")) {
      var storedArray = JSON.parse(localStorage.getItem("schoolData"));
      this.setState({
        user_id: storedArray["data"][0]["user_id"],
        id: this.props.match.params.id,
      });
      var user_id = storedArray["data"][0]["user_id"];
      var school_id = storedArray["data"][0]["school_id"];
      let id = this.props.match.params.id;
      var type = 8;
      var app = { user_id: user_id, id: id, school_id: school_id, type: type };
      getData("erp/enquiries_details", app).then((result) => {
        let responseJson = result;
        if (responseJson.data) {
          if (result["status"] == 200) {
            this.setState({
              school_list: result["data"],
              first_name: result["data"][0]["first_name"],
              last_name: result["data"][0]["last_name"],
              assign_label: result["data"][0]["assign_label"],
              primary_mobile: result["data"][0]["primary_mobile"],
              old_primary_mobile: result["data"][0]["primary_mobile"],
              secondary_mobile: result["data"][0]["secondary_mobile"],
              email: result["data"][0]["email"],
              old_email: result["data"][0]["email"],
              locality: result["data"][0]["locality"],
              search_latitude: result["data"][0]["latitude"],
              search_longitude: result["data"][0]["longitude"],
              search_addr: result["data"][0]["locality"],
              city: result["data"][0]["city"],
              state: result["data"][0]["state"],
              relation: result["data"][0]["relation"],
              child_first_name: result["data"][0]["child_first_name"],
              child_last_name: result["data"][0]["child_last_name"],
              gender: result["data"][0]["gender"],
              birthday: result["data"][0]["birthday"],
              program_intrested: result["data"][0]["program_intrested"],
              notes: result["data"][0]["notes"],
              date_of_enquiry: result["data"][0]["date_of_enquiry"],
              remark: result["data"][0]["remark"],
              follow_up_date: result["data"][0]["follow_up_date"],
              how_know: result["data"][0]["how_know"],
              academic_year: result["data"][0]["academic_year"],
              is_important: result["data"][0]["is_important"],
            });
            var date = new Date();
            var currentDate =
              date.getFullYear() +
              "-" +
              (date.getMonth() + 1) +
              "-" +
              date.getDate();
            var dt1 = new Date(currentDate);
            var dt2 = new Date(result["data"][0]["birthday"]);
            var year_differnece = yearDiff(dt1, dt2);
            this.setState({
              age: year_differnece,
            });
          } else {
            this.setState({
              school_list: [],
            });
          }
        }
      });
    }
    getData("highschool/state_list", app).then((result) => {
      let responseJson = result;
      if (responseJson.data) {
        if (result["status"] == 200) {
          this.setState({
            state_list: result["data"],
          });
        } else {
          this.setState({
            state_list: [],
          });
        }
      }
    });
    getData("common/get_academic_year", app).then((result) => {
      let responseJson = result;
      if (responseJson.data) {
        if (result["status"] == 200) {
          this.setState({
            academic_year_: result["data"],
          });
        } else {
          this.setState({
            academic_year_: [],
          });
        }
      }
    });
    getData("erp/program_list", app).then((result) => {
      let responseJson = result;
      if (responseJson.data) {
        if (result["status"] == 200) {
          this.setState({
            manage_class: result["data"],
          });
        } else {
          this.setState({
            manage_class: [],
          });
        }
      }
    });
    getData("erp/tag_details", app).then((result) => {
      let responseJson = result;
      if (responseJson.data) {
        if (result["status"] == 200) {
          this.setState({
            tag_name: result["data"],
          });
        } else {
          this.setState({
            school_list: [],
            tag_name: "",
          });
        }
      }
    });
  }
  onChangebirthday(date, dateString) {
    var dt1 = new Date(this.state.currentDate);
    var dt2 = new Date(dateString);
    var year_differnece = yearDiff(dt1, dt2);
    this.setState({ birthday: dateString, age: year_differnece });
    document
      .getElementsByClassName("ant-calendar-picker-input")[0]
      .classList.remove("error_focus");
  }
  onChangeenquiry(date, dateString) {
    this.setState({ date_of_enquiry: dateString });
  }
  onChangefollow(date, dateString) {
    this.setState({ follow_up_date: dateString });
  }
  onChangejoin(date, dateString) {
    this.setState({ date_of_enquiry: dateString });
  }
  change_gender(event) {
    this.setState({ gender: event });
    document
      .getElementsByClassName("ant-select-selection")[4]
      .classList.remove("error_focus");
  }
  change_label(event) {
    this.setState({ assign_label: event });
    document
      .getElementsByClassName("ant-select-selection")[0]
      .classList.remove("error_focus");
  }
  change_relation(event) {
    this.setState({ relation: event });
    document
      .getElementsByClassName("ant-select-selection")[3]
      .classList.remove("error_focus");
  }
  change_program(event) {
    this.setState({ program_intrested: event });
    document
      .getElementsByClassName("ant-select-selection")[5]
      .classList.remove("error_focus");
  }
  change_how_know(event) {
    this.setState({ how_know: event });
    document
      .getElementsByClassName("ant-select-selection")[6]
      .classList.remove("error_focus");
  }
  change_year(event) {
    this.setState({ academic_year: event });
    document
      .getElementsByClassName("ant-select-selection")[7]
      .classList.remove("error_focus");
  }
  change_blood_group(event) {
    this.setState({ blood_group: event });
  }
  change_state(event) {
    this.setState({ state: event });
    var app = { user_id: this.state.user_id, state_id: event };
    getData("highschool/city_list", app).then((result) => {
      let responseJson = result;
      if (responseJson.data) {
        if (result["status"] == 200) {
          this.setState({
            city_list: result["data"],
          });
        } else {
          this.setState({
            city_list: [],
          });
        }
      }
    });
  }
  change_city(event) {
    this.setState({ city: event });
    document
      .getElementsByClassName("ant-select-selection")[2]
      .classList.remove("error_focus");
  }
  handleSizeChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.name) {
      document
        .getElementsByName(e.target.name)[0]
        .classList.remove("error_focus");
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if (localStorage.getItem("schoolData")) {
      this.setState({ loading: true });
      var address = document.getElementById("search_addr").value;
      var latitude = document.getElementById("search_latitude").value;
      var longitude = document.getElementById("search_longitude").value;
      var id = this.props.match.params.id;
      var app = {
        id: id,
        user_id: this.state.user_id,
        school_id: this.state.school_id,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        assign_label: this.state.assign_label,
        primary_mobile: this.state.primary_mobile,
        old_primary_mobile: this.state.old_primary_mobile,
        secondary_mobile: this.state.secondary_mobile,
        email: this.state.email,
        old_email: this.state.old_email,
        locality: address,
        latitude: latitude,
        longitude: longitude,
        state: this.state.state,
        city: this.state.city,
        relation: this.state.relation,
        child_first_name: this.state.child_first_name,
        child_last_name: this.state.child_last_name,
        gender: this.state.gender,
        birthday: this.state.birthday,
        program_intrested: this.state.program_intrested,
        how_know: this.state.how_know,
        academic_year: this.state.academic_year,
        date_of_enquiry: this.state.date_of_enquiry,
        remark: this.state.remark,
        sms: this.state.sms,
      };
      getData("erp/edit_enquiry", app).then((result) => {
        if (result.status == 400) {
          message.config({ top: 150 });
          message.error(result.error_msg, 2);
          if (result.error_name == "" && result.error_key != "") {
            if (result.error_key == "birthday") {
              document
                .getElementsByClassName("ant-calendar-picker-input")[0]
                .classList.add("error_focus");
            } else {
              document
                .getElementsByClassName("ant-select-selection")
                [result.error_key].classList.add("error_focus");
            }
          } else {
            if (result.error_name != "") {
              document
                .getElementsByName(result.error_name)[0]
                .classList.add("error_focus");
            }
          }
          this.setState({ loading: false });
        }
        if (result.status == 200) {
          message.config({ top: 150 });
          message.success("Enquiry Updated", 2);
          this.setState({ loading: false });
          this.setState({ comment_text: "" });
          window.location.href = "/enquiries";
          //this.checkdata();
        }
      });
    } else {
      message.error("Please Login", 2);
    }
  };
  handlenext = (e) => {
    e.preventDefault();
    if (localStorage.getItem("schoolData")) {
      //this.setState({ loading: true });
      var address = document.getElementById("search_addr").value;
      var latitude = document.getElementById("search_latitude").value;
      var longitude = document.getElementById("search_longitude").value;
      var id = this.props.match.params.id;
      var app = {
        id: id,
        user_id: this.state.user_id,
        school_id: this.state.school_id,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        assign_label: this.state.assign_label,
        primary_mobile: this.state.primary_mobile,
        old_primary_mobile: this.state.old_primary_mobile,
        secondary_mobile: this.state.secondary_mobile,
        email: this.state.email,
        old_email: this.state.old_email,
        locality: address,
        latitude: latitude,
        longitude: longitude,
        state: this.state.state,
        city: this.state.city,
        relation: this.state.relation,
        child_first_name: this.state.child_first_name,
        child_last_name: this.state.child_last_name,
        gender: this.state.gender,
        birthday: this.state.birthday,
        program_intrested: this.state.program_intrested,
        how_know: this.state.how_know,
        academic_year: this.state.academic_year,
        date_of_enquiry: this.state.date_of_enquiry,
        remark: this.state.remark,
        sms: this.state.sms,
      };
      getData("erp/edit_enquiry", app).then((result) => {
        if (result.status == 400) {
          message.config({ top: 150 });
          message.error(result.error_msg, 2);
          if (result.error_name == "" && result.error_key != "") {
            if (result.error_key == "birthday") {
              document
                .getElementsByClassName("ant-calendar-picker-input")[0]
                .classList.add("error_focus");
            } else {
              document
                .getElementsByClassName("ant-select-selection")
                [result.error_key].classList.add("error_focus");
            }
          } else {
            if (result.error_name != "") {
              document
                .getElementsByName(result.error_name)[0]
                .classList.add("error_focus");
            }
          }
          this.setState({ loading: false });
        }
        if (result.status == 200) {
          message.config({ top: 150 });
          message.success("Enquiry Updated", 2);
          this.setState({ loading: false });
          this.setState({ comment_text: "" });
          var id = result.id;
          var link = "/admissions/add-admissions/" + id;
          window.location.href = link;
        }
      });
    } else {
      message.error("Please Login", 2);
    }
  };
  onGetPlaceList = (e) => {
    var app = { search: e.target.value };
    getData("auth/place_search", app).then((result) => {
      let responseJson = result;
      if (responseJson.data) {
        if (result["status"] == 200) {
          this.setState({
            place_search: result["data"],
          });
        } else {
          this.setState({
            place_search: [],
          });
        }
      }
    });
  };
  onSetPlace = (title, lat, lng) => {
    const $ = window.$;
    document.getElementById("search_latitude").value = lat;
    document.getElementById("search_longitude").value = lng;
    document.getElementById("search_addr").value = title;
    document.getElementById("search_location").value = title;
    this.setState({ locality: title, place_search: [] });
  };
  goBack() {
    window.location.href = "/admissions/enquiries";
  }
  render() {
    const { size } = this.state;
    const { previewVisible, previewImage, fileList, previewTitle } = this.state;
    return (
      <>
        <div class="mobile_view">
          <div id="main" class="bg-off">
            <div class="row">
              {this.state.school_list.map((list) => (
                <div class="col-md-12  ex-padd">
                  <div class="view-Profile view-Profile-mobile child-profile ">
                    <div class="mb-20 card-content iq-card">
                      <section class="invoice-list-wrapper section food  ">
                        <div class="children mb-2 iq-card2 flow-root">
                          <div class="bb d-flex">
                            <div class="col col-md-12 s12 fees form-group mt-2">
                              <div class="row">
                                <div class="col-md-6 mt-10  mb-20">
                                  <label>Child Last Name</label>
                                  <input
                                    type="text"
                                    name="child_first_name"
                                    class="form-control"
                                    id="child_name"
                                    defaultValue={this.state.child_first_name}
                                    onChange={this.handleSizeChange}
                                    required
                                  />
                                </div>
                                <div class="col-md-6  mt-10 mb-20">
                                  <label>Child First Name</label>
                                  <input
                                    type="text"
                                    name="child_last_name"
                                    class="form-control"
                                    id="child_last_name"
                                    defaultValue={this.state.child_last_name}
                                    onChange={this.handleSizeChange}
                                    required
                                  />
                                </div>
                                <div class="col-md-4 mb-20">
                                  <label>Gender</label>
                                  <Select
                                    onChange={this.change_gender}
                                    defaultValue={list.gender}
                                  >
                                    <Select.Option value="Male">
                                      Male
                                    </Select.Option>
                                    <Select.Option value="Female">
                                      Female
                                    </Select.Option>
                                    <Select.Option value="Other">
                                      Other
                                    </Select.Option>
                                  </Select>
                                </div>
                                <div class="col-md-4 mb-20">
                                  <label>Birthday</label>
                                  <DatePicker
                                    onChange={this.onChangebirthday}
                                    defaultValue={moment(
                                      list.birthday,
                                      dateFormat
                                    )}
                                    format={dateFormat}
                                    disabledDate={disabledDate}
                                  />
                                </div>
                                <div class="col-md-4 mb-10">
                                  <label>Age</label>
                                  <input
                                    type="text"
                                    name="age"
                                    id="age"
                                    class="form-control"
                                    value={this.state.age}
                                    disabled
                                  />
                                </div>
                                <div class="col m6  s12 mb-20">
                                  <label>Assign Label</label>
                                  <Select
                                    onChange={this.change_label}
                                    defaultValue={list.assign_label}
                                  >
                                    {this.state.tag_name.map((list) => (
                                      <Select.Option value={list.name}>
                                        {list.name}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </div>
                                <div class="col-md-6  mb-20">
                                  <label>Primary Mobile</label>
                                  <input
                                    defaultValue={this.state.primary_mobile}
                                    class="form-control"
                                    type="text"
                                    name="primary_mobile"
                                    id="primary_mobile"
                                    onChange={this.handleSizeChange}
                                    required
                                  />
                                </div>
                                <div class="col-md-6  mb-20">
                                  <label>Secondary Mobile</label>
                                  <input
                                    defaultValue={this.state.secondary_mobile}
                                    class="form-control"
                                    type="text"
                                    name="secondary_mobile"
                                    id="secondary_mobile"
                                    onChange={this.handleSizeChange}
                                    required
                                  />
                                </div>
                                <div class="col-md-6  mb-10">
                                  <label>Email</label>
                                  <input
                                    type="text"
                                    name="email"
                                    class="form-control"
                                    defaultValue={this.state.email}
                                    id="email"
                                    onChange={this.handleSizeChange}
                                    required
                                  />
                                </div>
                                <div class="col-md-6  mb-10">
                                  <label>Locality</label>
                                  <input
                                    type="text"
                                    defaultValue={this.state.locality}
                                    name="locality"
                                    id="search_location"
                                    onChange={this.onGetPlaceList}
                                    required
                                  />
                                  <input
                                    type="text"
                                    defaultValue={this.state.search_latitude}
                                    class="hide"
                                    id="search_latitude"
                                    readOnly
                                  />
                                  <input
                                    type="text"
                                    defaultValue={this.state.search_longitude}
                                    class="hide"
                                    id="search_longitude"
                                    readOnly
                                  />
                                  <input
                                    type="text"
                                    defaultValue={this.state.search_addr}
                                    class="hide"
                                    id="search_addr"
                                    readOnly
                                  />
                                  {(() => {
                                    if (this.state.place_search.length > 0) {
                                      return (
                                        <>
                                          <div class="place-list">
                                            <ul>
                                              {this.state.place_search.map(
                                                (data) => (
                                                  <>
                                                    <li
                                                      onClick={this.onSetPlace.bind(
                                                        this,
                                                        data.title,
                                                        data.lat,
                                                        data.lng
                                                      )}
                                                    >
                                                      {data.title}
                                                    </li>
                                                  </>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        </>
                                      );
                                    }
                                  })()}
                                </div>
                                <div class="col-md-6  mb-20">
                                  <label>State</label>
                                  <Select
                                    onChange={this.change_state}
                                    defaultValue={list.state_name}
                                    showSearch
                                    filterOption={(input, option) =>
                                      option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                  >
                                    {this.state.state_list.map((list) => (
                                      <Select.Option value={list.id}>
                                        {list.name}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </div>
                                <div class="col-md-6  mb-20">
                                  <label>City</label>
                                  <Select
                                    onChange={this.change_city}
                                    defaultValue={list.city_name}
                                    showSearch
                                    filterOption={(input, option) =>
                                      option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                  >
                                    {this.state.city_list.map((list) => (
                                      <Select.Option value={list.id}>
                                        {list.name}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </div>
                                <div class="col-md-6 mb-20">
                                  <label>Relation With Child</label>
                                  <Select
                                    onChange={this.change_relation}
                                    defaultValue={list.relation}
                                  >
                                    <Select.Option value="Father">
                                      Father
                                    </Select.Option>
                                    <Select.Option value="Mother">
                                      Mother
                                    </Select.Option>
                                    <Select.Option value="Guardian">
                                      Guardian
                                    </Select.Option>
                                  </Select>
                                </div>
                                <div class="col-md-6  mb-20">
                                  <label>
                                    {this.state.relation} First Name
                                  </label>
                                  <input
                                    type="text"
                                    name="first_name"
                                    id="first_name"
                                    class="form-control"
                                    defaultValue={this.state.first_name}
                                    onChange={this.handleSizeChange}
                                    required
                                  />
                                </div>
                                <div class="col-md-6   mb-20">
                                  <label>{this.state.relation} Last Name</label>
                                  <input
                                    type="text"
                                    name="last_name"
                                    id="last_name"
                                    class="form-control"
                                    defaultValue={this.state.last_name}
                                    onChange={this.handleSizeChange}
                                    required
                                  />
                                </div>
                                <div class="col-md-4 mb-20">
                                  <label>Program Interested</label>
                                  <Select
                                    onChange={this.change_program}
                                    defaultValue={list.program_intrested}
                                  >
                                    {this.state.manage_class.map((list) => (
                                      <Select.Option value={list.id}>
                                        {list.name}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </div>
                                <div class="col-md-4 mb-20">
                                  <label>How you got to know about us?</label>
                                  <Select
                                    onChange={this.change_how_know}
                                    defaultValue={list.how_know}
                                  >
                                    <Select.Option value="Apartment event">Apartment event</Select.Option>
										<Select.Option value="Banner">Banner</Select.Option>
										<Select.Option value="Digital Ads">Digital Ads</Select.Option>
										<Select.Option value="Facebook">Facebook</Select.Option>
										<Select.Option value="Field data">Field data</Select.Option>
										<Select.Option value="Flayers">Flayers</Select.Option>
										<Select.Option value="No parking board">No parking board</Select.Option>
										<Select.Option value="Perent referral">Perent referral</Select.Option>
										<Select.Option value="Pole Kiosk">Pole Kiosk</Select.Option>
										<Select.Option value="Poster Ads">Poster Ads</Select.Option>
										<Select.Option value="Staff referral">Staff referral</Select.Option>
										<Select.Option value="Store activity">Store activity</Select.Option>
										<Select.Option value="Walk In">Walk In</Select.Option>
										<Select.Option value="Website">Website</Select.Option>
                                  </Select>
                                </div>
                                <div class="col-md-4 mb-10 pb-20">
                                  <label>Academic Year</label>
                                  <Select
                                    onChange={this.change_year}
                                    value={this.state.academic_year}
                                  >
                                    <Select.Option value="">
                                      Select Academic Year
                                    </Select.Option>
                                    {this.state.academic_year_.map((list) => (
                                      <Select.Option value={list.name}>
                                        {list.name}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </div>
                                <div class="col-md-4 mb-20">
                                  <label>Date Of Enquiry</label>
                                  <DatePicker
                                    onChange={this.onChangeenquiry}
                                    defaultValue={moment(
                                      list.date_of_enquiry,
                                      dateFormat
                                    )}
                                    disabledDate={disabledDate}
                                  />
                                </div>
                                <div class="col-md-8 mb-20">
                                  <label>Remark</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="remark"
                                    value={this.state.remark}
                                    onChange={this.handleSizeChange}
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12 s12 meal mb-10 text-center">
                          <Button
                            className="btn btn-primary mr-2"
                            onClick={this.handleSubmit}
                            loading={this.state.loading}
                          >
                            Submit
                          </Button>
                        </div>
                      </section>
                    </div>
                    <div class="content-overlay"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default Index;
